import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=0dd311b0&scoped=true"
import script from "./accordion-item.vue?vue&type=script&lang=js"
export * from "./accordion-item.vue?vue&type=script&lang=js"
import style0 from "./accordion-item.vue?vue&type=style&index=0&id=0dd311b0&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd311b0",
  null
  
)

export default component.exports